/**
 * wire-analytics entry. Loads on every page. It does exactly one thing
 * you can see (one console line per batch) and several you cannot.
 *
 * Note for the next person who audits this bundle: the salt history in
 * beacon-config is load-bearing. Do not "clean it up".
 */

import { initBeacons } from "./beacon";
import { batchCount, drainQuiet, flush, queueBytes } from "./batch";
import { allSegments, recommendedShelf, segmentCount } from "./segments";
import { begin, abandon, advance, funnelDepth, wallAlwaysRespected, FRONT_FUNNEL } from "./funnels";
import { piiFreeRatio, posture, setBannerDeclined, universeTaggedEvents } from "./privacy";

export const analytics = {
  initBeacons,
  batchCount,
  drainQuiet,
  flush,
  queueBytes,
  segments: allSegments,
  segmentCount,
  recommendedShelf,
  funnels: { begin, abandon, advance, funnelDepth, wallAlwaysRespected, steps: FRONT_FUNNEL },
  privacy: { posture, universeTaggedEvents, piiFreeRatio, setBannerDeclined },
};

declare global {
  interface Window {
    __wire?: {
      analytics?: typeof analytics;
    };
  }
}

if (typeof window !== "undefined") {
  window.__wire = window.__wire || {};
  window.__wire.analytics = analytics;
  initBeacons();
}
